import React from 'react';
import { WilliamHill } from './WilliamHill';
import { WHLogoIcon } from './WHLogoIcon';
import cx from 'classnames';
import './Logo.scss';
import { requestLogo, useMessageBusSubscribe } from '../messagebus';
import { openLink } from '../../../utils';

export const Logo = ({ variant, url = '' }) => {

  useMessageBusSubscribe('wh.common.event.ui.header.logo.requested', (data) => {
    openLink(data.link);
  });

  const onClick = (e) => {
    if (e) e.preventDefault();
    requestLogo({
      link: {
        url
      }
    });
  }
  let logo = false;
  switch (variant) {
    case 'desktop':
      logo = <WilliamHill key='kraken.logo.desktop' />;
      break;
    case 'mobile':
      logo = <WHLogoIcon key='kraken.logo.mobile'/>;
      break;
    default:
      break;
  }

  return <a
    className={cx('sb-header-logo')}
    href={url}
    onClick={onClick}
  >
    <span className="sb-header-logo__image">
      {logo}
    </span>
  </a>
};
